import { Controller } from "@hotwired/stimulus"

const LIGHT_THEME = "zcr"
const DARK_THEME = "zcr-dark"

export default class extends Controller {
  static targets = ["menu", "button", "icon"]

  connect() {
    this.mediaQuery = window.matchMedia("(prefers-color-scheme: dark)")
    this.onSystemThemeChange = this.onSystemThemeChange.bind(this)
    this.mediaQuery.addEventListener("change", this.onSystemThemeChange)

    const preference = this.storedPreference()
    this.applyTheme(preference)
    this.updateIcon(preference)
  }

  disconnect() {
    this.mediaQuery.removeEventListener("change", this.onSystemThemeChange)
  }

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")

    const isExpanded = !this.menuTarget.classList.contains("hidden")
    this.buttonTarget.setAttribute("aria-expanded", isExpanded)
  }

  select(event) {
    event.stopPropagation()
    const theme = event.currentTarget.dataset.themeName

    if (theme === "system") {
      localStorage.removeItem("theme")
    } else {
      localStorage.setItem("theme", theme)
    }

    this.applyTheme(theme)
    this.updateIcon(theme)
    this.menuTarget.classList.add("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "false")
  }

  onSystemThemeChange() {
    if (this.storedPreference() !== "system") return

    this.applyTheme("system")
    this.updateIcon("system")
  }

  storedPreference() {
    const saved = localStorage.getItem("theme")
    if (saved === "light" || saved === "dark") return saved
    return "system"
  }

  applyTheme(theme) {
    document.documentElement.setAttribute("data-theme", this.resolveTheme(theme))
  }

  resolveTheme(theme) {
    if (theme === "dark") return DARK_THEME
    if (theme === "light") return LIGHT_THEME

    return this.mediaQuery.matches ? DARK_THEME : LIGHT_THEME
  }

  updateIcon(theme) {
    if (!this.hasIconTarget) return

    const effectiveTheme = this.resolveTheme(theme)
    const sunIcon =
      '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"></path>'
    const moonIcon =
      '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"></path>'

    this.iconTarget.innerHTML = effectiveTheme === LIGHT_THEME ? sunIcon : moonIcon
  }

  clickOutside(event) {
    if (!this.element.contains(event.target) && !this.menuTarget.classList.contains("hidden")) {
      this.menuTarget.classList.add("hidden")
      this.buttonTarget.setAttribute("aria-expanded", "false")
    }
  }
}
